import React from 'react'
import styles from './Tag.module.scss'
import cl from 'classnames'
import { TagProps } from './Tag.types'
import { Button } from '../Button'
import { IconDelete } from 'assets'

const TagComponent = (props: TagProps) => {
  const {
    tag,
    children,
    className,
    style,
    removable,
    onRemove
  } = props

  const handleOnRemoveClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    onRemove && onRemove()
  }

  return (
    <span
      className={cl(styles.tag, styles.textOverflow, {
        [styles.removable]: removable
      }, className)}
      title={tag}
      style={style}
    >
      {tag}{children}
      {removable && (
        <Button
          preset='icon'
          className={styles.tabButton}
          onClick={handleOnRemoveClick}
        >
          <IconDelete fill={'#d8d8d8'} />
        </Button>
      )}
    </span>
  )
}

const Tag = TagComponent
export { Tag }
